// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__2TB2N","pencil":"IconEdit_pencil__2o2v0"};